import { useSettings } from './useSettings'

export type BetaFeature = {
  key: string
  title: string
  description: string
}

export const useBetaFeature = (key: string) => {
  const settings = useSettings()
  const betaFeaturesEnabled = settings.get.betaFeaturesEnabled ?? {}
  const enabled = betaFeaturesEnabled[key] ?? false

  const setEnabled = (nextEnabled: boolean): void => {
    settings.set({
      betaFeaturesEnabled: {
        ...betaFeaturesEnabled,
        [key]: nextEnabled
      }
    })
  }

  return {
    enabled,
    setEnabled,
    isSuccess: settings.isSuccess,
    isPending: settings.isPending,
    isError: settings.isError
  }
}
